// extracted by mini-css-extract-plugin
export default {"wrapper":"LabelValue_wrapper__ib+B4","heading":"LabelValue_heading__dpfas","value":"LabelValue_value__quh52"};